import onlyLetters from './onlyLetters'
import onlyNumbers from './onlyNumbers'
import onlyNumbersAndLetters from './onlyNumbersAndLetters'
import removeSpaces from './removeSpaces'

const regex = {
  onlyLetters,
  onlyNumbers,
  onlyNumbersAndLetters,
  removeSpaces,
}

export default regex
